import Header from '../modules/header';
import Social from '../modules/social';

const Barba = require('barba.js');

let socialInitialized = false;

const Home = Barba.BaseView.extend({
    namespace: 'home',

    onEnter() {
        this.$barbaWrapper = $('#barba-wrapper');
        this.header = new Header();
        this.header.enterHomeState();

        if (socialInitialized === false) {
            new Social();
            socialInitialized = true;
        }

        if ($('html').hasClass('fp-enabled')) {
            $.fn.fullpage.destroy('all');
        }

        if (this.$barbaWrapper.hasClass('fp-destroyed')) {
            this.$barbaWrapper.removeClass('fp-destroyed');
            this.$barbaWrapper.removeAttr('style');
        }
    },

    onLeaveCompleted() {
        this.header.leaveHomeState();
    },
});

export { Home as default };



// WEBPACK FOOTER //
// ./frontend/js/views/home.js